import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f98ec55c&scoped=true"
import script from "./composition.js?vue&type=script&lang=js&external"
export * from "./composition.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=f98ec55c&prod&lang=scss&scoped=true&external"
import style1 from "./unscoped_styles.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98ec55c",
  null
  
)

export default component.exports